// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"77183a09","631":"82596105","747":"25ca228f","839":"68f36c06"}[chunkId] + ".chunk.js";
};